// extracted by mini-css-extract-plugin
export default {"Container":"EducationExpenseExtraFee_Container__0t7TM"};